exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bind-tip[data-v-214a8554] {\n  margin-bottom: 14px;\n  color: #666;\n  font-size: 13px;\n}\n", ""]);

// exports
